import { NgFor, NgIf } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ApiService } from '../../core/api.service';
import { LocalDatePipe } from '../../core/date-utils';
import { Cliente, Contagem } from '../../core/models';

@Component({
  standalone: true,
  imports: [ReactiveFormsModule, NgFor, NgIf, RouterLink, LocalDatePipe],
  template: `
    <header class="page-header">
      <div><h2>Histórico de contagens</h2><p>Pesquisa e romaneios emitidos</p></div>
      <a class="primary-link" routerLink="/contagens/nova">Nova contagem</a>
    </header>

    <section class="panel">
      <form class="grid-form" [formGroup]="filtros" (ngSubmit)="carregar()">
        <label>Cliente
          <select formControlName="id_cliente">
            <option value="">Todos</option>
            <option *ngFor="let cliente of clientes" [value]="cliente.id_cliente">{{ cliente.nome }}</option>
          </select>
        </label>
        <label>Data inicial<input type="date" formControlName="data_inicial"></label>
        <label>Data final<input type="date" formControlName="data_final"></label>
        <label>Referência<input formControlName="referencia"></label>
        <label>Status
          <select formControlName="status">
            <option value="">Todos</option>
            <option>ABERTA</option>
            <option>FINALIZADA</option>
            <option>CANCELADA</option>
          </select>
        </label>
        <button type="submit">Pesquisar</button>
      </form>
    </section>

    <table class="data-table">
      <thead>
        <tr><th>Código</th><th>Cliente</th><th>Produto</th><th>Data</th><th>Referência</th><th>Cor</th><th>Total</th><th>Status</th><th></th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let contagem of contagens">
          <td data-label="Código">{{ contagem.id_contagem }}</td>
          <td data-label="Cliente">{{ contagem.cliente }}</td>
          <td data-label="Produto">{{ contagem.produtos_resumo || contagem.codigo_produto || '-' }}</td>
          <td data-label="Data">{{ contagem.data_contagem | localDate }}</td>
          <td data-label="Referência">{{ contagem.referencia }}</td>
          <td data-label="Cor">{{ contagem.cor }}</td>
          <td data-label="Total">{{ contagem.total_pecas }}</td>
          <td data-label="Status"><span class="status" [class.finalizada]="contagem.status === 'FINALIZADA'" [class.cancelada]="contagem.status === 'CANCELADA'">{{ contagem.status }}</span></td>
          <td class="actions" data-label="Ações">
            <a [routerLink]="['/contagens', contagem.id_contagem]">Visualizar</a>
            <a *ngIf="contagem.status === 'ABERTA'" [routerLink]="['/contagens', contagem.id_contagem, 'editar']">Editar</a>
            <button *ngIf="contagem.status === 'FINALIZADA'" type="button" (click)="reabrir(contagem)">Reabrir</button>
            <button type="button" (click)="romaneio(contagem)">PDF</button>
            <button *ngIf="contagem.status === 'ABERTA'" type="button" (click)="excluir(contagem)">Excluir</button>
          </td>
        </tr>
      </tbody>
    </table>
  `
})
export class ContagemListaComponent implements OnInit {
  private api = inject(ApiService);
  private fb = inject(FormBuilder);
  clientes: Cliente[] = [];
  contagens: Contagem[] = [];

  filtros = this.fb.nonNullable.group({
    id_cliente: [''],
    data_inicial: [''],
    data_final: [''],
    referencia: [''],
    status: ['']
  });

  ngOnInit() {
    this.api.clientes().subscribe((clientes) => (this.clientes = clientes));
    this.carregar();
  }

  carregar() {
    this.api.contagens(this.filtros.getRawValue()).subscribe((contagens) => (this.contagens = contagens));
  }

  romaneio(contagem: Contagem) {
    this.api.abrirRomaneio(contagem.id_contagem);
  }

  reabrir(contagem: Contagem) {
    const confirmar = window.confirm(`Reabrir a contagem ${contagem.id_contagem} para edição?`);
    if (!confirmar) return;

    this.api.reabrirContagem(contagem.id_contagem).subscribe(() => this.carregar());
  }

  excluir(contagem: Contagem) {
    this.api.excluirContagem(contagem.id_contagem).subscribe(() => this.carregar());
  }
}
